<!--
 * @Author: 317473294@qq.com
 * @Date: 2022-05-07 16:32:40
 * @LastEditTime: 2025-05-09 20:02:55
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /frontEnd/src/views/login/login.vue
-->
<template>
    <div class="login-bg">

        <div class="login-title">寰铭教育后台管理系统 </div>
        <div class="login-content">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules"  @submit.native.prevent>
                <el-form-item label="用户名:" prop="username">
                    <el-input prefix-icon="el-icon-user-solid" placeholder="请输入用户名" v-model="form.username" >
                </el-input>
                </el-form-item>
                <el-form-item label="密码：" prop="password">
                    <el-input prefix-icon="el-icon-lock" placeholder="请输入密码" type="password" v-model="form.password">
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <div class="tip">
                        {{ loginTip }}
                        <router-link v-if="code == 404" to="/menu">请注册</router-link>
                    </div>
                    <div class="login-denglu">
                        <el-button type="primary" native-type="submit" @click="ondenglu('form')">登录</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>

import {validateUserName,validateUserPassword} from "@/utils/validate.js"
import { login } from "@/api/user.js"
import { addLog } from "@/api/loginLog.js"
import {initMenuData} from "@/router"
import {roleMenu} from "@/utils/rolemenu.js"
import {getCurrentDateTime} from "@/utils/time.js"
import {tools} from "@/utils/tools.js"
import { getRoleMenuIds } from "@/router/dtRouter.js";
import Vue from 'vue'
import {asyRouterList} from "@/router/test.js"
/**
 * @description: tt
 * @param {*}aa
 * @return {*}cc
 */
export default {
    name: "Login",
    data() {

        return {
            resOver:'',
            loginTip: "",
            code: "",
            form: {
                username: "",
                password: ""
            },

            rules: {
                   username: [{ required: true, message: '用户名不能为空', trigger: 'blur' }],
                   password: [{ required: true, message: '密码不能为空', trigger: 'blur' }],
            }
        }
    },
    created(){

    },
    methods: {
        //测试mock
        // testMock(){
            
        //     axios.post('api/login').then((res)=>{
        //     ////console.log(res)
        //     })
        //     axios.get('api/user').then((res)=>{
        //     ////console.log(res)
        //     })
        // }, 

        
        ondenglu(form) {
            // this.testMock();
            this.$refs[form].validate((valid) => {
                if (valid) {
                    this.sendPost()
                } else {
                    this.$message({
                        message: '登录失败,请按要求输入用户名和密码！',
                        type: 'warning'
                    })
                    return false;
                }
            });

            // ////console.log(this.baseURL + adminUser)
            // return this.$router.push("/Home")
        },
          /**
         * @description: 检测用户名及密码是否存在，存在则发送post请求，后台如果存在该用户名及密码，则返回token
         * 拿到token后通过vuex保存到本地；
         * @param {*}
         * @return {*}
         */
        async sendPost(){
            // return this.$router.push("/Home")
            login(this.form)
                .then(async (res) => {
                    console.log("请求返回的结果", res)
                    if (res.data.status == 200) {
                        // //console.log('登陆', res.data.token)
                        this.$message({
                            message: '登陆成功',
                            type: 'success'
                        })
                        this.code = res.data.status
                        //存储用户信息
                        this.saveLoginLog(res.data.username)
                        const userinfo={userid:res.data.userid,username:res.data.username,roleid:res.data.roleid}
                        this.$store.commit("setUserInfo", userinfo)
                        //存储token
                        this.$store.commit("setToken", res.data.token)
                           //存储刷新token
                           this.$store.commit("setRefreshToken", res.data.refreshToken)
                        //获取角色菜单id数组
                         const ids=await getRoleMenuIds(res.data.roleid)
                         //console.log("权限菜单数组")
                         //console.log(ids)
                           //存储权限菜单
                        this.$store.commit("setRoleMenu",ids)
                        // this.$router.addRoutes(ids)
                    //     let data=await roleMenu({id:res.data.roleid})
                    //     let meunsids=data[0].limtauthority//拿到权限菜单id字符串
                    //     let menusArray = meunsids.split(",");//把字符串转成数组,这逗号是中文
                    //     //console.log("idstr",meunsids)
                    //     //console.log("ids",menusArray)
                    //     //从服务器获取菜单，参数为菜单id数组
                    //     initMenuData({ids:menusArray}).then((res)=>{
                    //         //console.log("获取的权限菜单",res)
                    //         //存储权限菜单
                    //     this.$store.commit("setRoleMenu", res)
                    //     this.$router.push(res[0].children[0].path)//显示首页大屏
                    //     // this.$router.push("/bigScreen")//显示首页大屏
                    //    })
                    this.$router.push("/bigScreen")//显示首页大屏
                        // 
                        return
                    }
                    //没有找到
                    this.loginTip = res.data.msg
                    this.code = res.data.status
                    if (res.data.status == 404) {
                        this.$message({
                            message: res.data.msg,
                            type: 'wrong'
                        })
                    }


                })
    },
          
    //登录信息存储到数据库
      saveLoginLog(username){
        let time=getCurrentDateTime()
        let logid=tools.getRandomLetters()
        let ip=tools.getIp()
       
        let obj={
            username:username,
            login_time:time,
            logid:logid
        }
        addLog(obj).then((res)=>{
             //console.log("添加日志信息",res)
             tools.localData("set",res.data.data.logid)
        })
      }
        
        }
}
</script>
<style scoped>
.login-bg {
    background-color: #2d3a4b;
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: 0;
    padding: 0;
}

.login-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 30%;
    height: 300px;
    top: 20%;
    bottom: 40%;
    left: 35%;
    right: 35%;
    /* background-color: #1F2734; */
    /* border-radius: 10px; */
    z-index: 1
}

.login-title {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 10%;
    left: 0;
    right: 0;
    text-align: center;
    color: #eee;
    font-size: 30px;
    font-weight: bold;
    z-index: 2
}

.login-username,
.login-password,
.login-denglu {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.login-password {
    margin-top: 30px;
    margin-bottom: 10px;
}

.login-denglu {
    position: relative;

}

.tip {
    margin-bottom: 10px;
    color: #fff;
    line-height: 20px;
    height: 20px;
    font-size: .1rem;
}

span {
    display: block;
    width: 100px;
    color: #fff;
    font-size: 18px;
}

>>>.el-form {
    background-color: #1F2734;
    border-radius: 10px;
    padding: 30px;
}

>>>.el-input__inner {
    background-color: #1F2734;
    color: #fff;
    text-align: left;
    text-indent: 20px;

}

>>>.el-button {
    width: 300px;

}

>>>.el-button {
    width: 300px;
}

>>>.el-input__icon {
    font-size: 20px;
    margin-left: 10px;
    margin-right: 10px;

}

>>>.el-input__inner::placeholder {
    /* text-align: center; */
    /* display: block; */
    /* position: relative;
        left: 10px; */
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue